import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, SubmissionError } from 'redux-form'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Button, Confirm } from 'semantic-ui-react'
import { CardContent, Collapse } from '@material-ui/core'
import { approverDownPaymentAction, setDownpaymentActionName, updateDownPayment } from 'ducks/downPayment'
import { getHrmsMembers,getAllMembers } from 'ducks/member'
import { DPContainer, BottomActionsContainer, InputCont, InputCont1 } from './styled'
import r from 'reactotron-react-js'

const Requestdocument = (props) => {
  const { dpDetail = {},
    approverDownPaymentAction,
    requireInterimPayment,
    valueForm,
    handleSubmit,
    dpActionName,
    members,
    history } = props

  const approverAction = dpDetail.actions || []
  const sn = dpDetail.sn || ''
  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  React.useEffect(() => {
    if (!members.length) {
      props.getAllMembers()
      // props.getHrmsMembers()
    }
  }, [])

  function submitValidate(dpActionName) {
    setSubmitActionName(dpActionName)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    console.log(dpActionName)
    return sleep(100)
      .then(() => {
        let errors = validateField(valueForm, dpActionName)
        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          let data = { ...valueForm, }
          if (dpActionName === 'send') {
            props.updateDownPayment(data, history,true)
          }
          if (dpActionName === 'revise') {
            // props.submitDP(valueForm, history, dpActionName)
          }
          if (dpActionName === 'submit') {
            props.updateDownPayment(data, history, dpActionName)
          }
          if (dpActionName === 'Revise To Purchase') {
            // console.log(valueForm)
            // props.submitDP(valueForm, history, dpActionName)
          }
          if (dpActionName === 'Revise To Vendor') {
            // console.log(valueForm)
            // props.submitDP(valueForm, history, dpActionName)
          } 
          if (dpActionName === 'cancel') {
            // props.submitDP(valueForm, history, dpActionName)
          }
        }
        setShowConfirm(true)
      })
  }
  
  function submitAction() {
    setShowConfirm(false)
    approverDownPaymentAction({
      docId: valueForm.id,
      sn: sn,
      action: submitActionName,
      comment: valueForm.comment,
      commentAttachments: valueForm.commentAttachments,
      attachmentsInterims: valueForm.DP02,
      attachmentInvoices: valueForm.DP01
    }, history)
  }

  return (
    <React.Fragment>
      {valueForm.statusActivity === 'Procurement Check Document' ?
        <StdCard title='Payment Type :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
          <Field
            name="paymentType"
            label="PaymentType"
            type={type.radio}
            require
            options={
              dpDetail.isVendThai ? [
                { text: 'Cash', value: 'cash' },
                { text: 'Cheque', value: 'cheque' },
                { text: 'Transfer', value: 'transfer' }] :
                [{ text: 'Wire Tranfer', value: 'wireTranfer' }]
            }
            editable={dpDetail.isVendThai}
            component={FieldInput}
          />
          <Field
            name="dueDate"
            label="Due Date"
            className='halfRow'
            type={type.date}
            editable={false}
            component={FieldInput}
          />
          <br />
          {/* {r.log({ valueForm })} */}
          {/* {console.log(valueForm.requireInterimPayment)}
          {console.log('Length:' + valueForm.downPaymentProjectOwnerItems.length)} */}
          <Field
            name="requireInterimPayment"
            label="Request Document From  Project Manager / Project Owner :"
            require
            type={type.switch}
            component={FieldInput}
          />
          <Collapse in={requireInterimPayment}>
            <CardContent>
              {<DPContainer>
                <Field
                  name="downPaymentProjectOwnerItems"
                  label=" Send To :"
                  require
                  type={type.multiSelect} 
                  options={
                    members.map(x => ({ value: x.username, text: `${x.firstnameEn} ${x.lastnameEn}` }))
                  }
                  editable={dpDetail.isVendThai}
                  component={FieldInput}
                />
              </DPContainer>}
            </CardContent>
          </Collapse>

          <InputCont>
            <Field
              name='comment'
              label='Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <Field name='DP02' label='Require Payment Certificate / Interim Payment / Acknowledged Doc. :' type={type.file} component={FieldInput} />
          </InputCont>
          <BottomActionsContainer>
            {
              requireInterimPayment ?
                <Button
                  type='submit'
                  content='Submit To PM'
                  color='green'
                  onClick={handleSubmit(() => submitValidate('send'))}
                /> :
                <Button
                  type='submit'
                  content='Submit To Accounting'
                  color='green'
                  onClick={handleSubmit(() => submitValidate('submit'))}
                />
            }

            {
              dpDetail.isVendThai ?
                <Button
                  type='submit'
                  content='Revise To Vendor'
                  color='orange'
                  onClick={handleSubmit(() => submitValidate('revise'))}
                /> : null
            }

            <Button
              type='submit'
              content='Cancel'
              color='red'
              onClick={handleSubmit(() => submitValidate('cancel'))}
            />
          </BottomActionsContainer>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </StdCard>
        : null
      }
      {valueForm.statusActivity === 'Procurement Upload Document' ?
        <StdCard title='Comment :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
          <DPContainer>
            <InputCont1>
              <Field
                name="paymentType"
                label="PaymentType"
                type={type.radio}
                require
                options={
                  dpDetail.isVendThai ? [
                    { text: 'Cash', value: 'cash' },
                    { text: 'Cheque', value: 'cheque' },
                    { text: 'Transfer', value: 'transfer' }] :
                    [{ text: 'Wire Tranfer', value: 'wireTranfer' }]
                }
                editable={dpDetail.isVendThai}
                component={FieldInput}
              />
              <Field
                name="dueDate"
                label="Due Date"
                className='halfRow'
                type={type.date}
                editable={false}
                component={FieldInput}
              />

              <Field
                name='comment'
                label='Comment'
                type={type.textArea}
                containerStyle={{ marginRight: '0px' }}
                component={FieldInput} />
              <div className="rowFields" >
                <Field name='DP01' label='Invoice / Tax Invoice :' type={type.file} component={FieldInput} require />
                <Field name='DP02' label='Require Payment Certificate / Interim Payment / Acknowledged Doc. :' type={type.file} component={FieldInput} />
              </div>
              <BottomActionsContainer>
                <Button
                  type='submit'
                  content='Submit'
                  color='green'
                  onClick={handleSubmit(() => submitValidate('submit'))}
                />
                <Button
                  type='submit'
                  content='Cancel'
                  color='red'
                  onClick={handleSubmit(() => submitValidate('cancel'))}
                />

              </BottomActionsContainer>
            </InputCont1>
            <Confirm
              size='mini'
              open={showConfirm}
              onCancel={() => setShowConfirm(false)}
              onConfirm={() => submitAction()}
            />
          </DPContainer>
        </StdCard> : null
      }
      {
        valueForm.statusActivity === 'Project Owner' ?
          <StdCard title='Comment :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
            <DPContainer>
              <InputCont>
                <Field
                  name='comment'
                  label='Comment'
                  type={type.textArea}
                  containerStyle={{ marginRight: '0px' }}
                  component={FieldInput} />
                <Field name='DP02' label='Require Payment Certificate / Interim Payment / Acknowledged Doc. :' type={type.file} component={FieldInput} require />

                <BottomActionsContainer>
                  <Button
                    type='submit'
                    content='Submit'
                    color='green'
                    onClick={handleSubmit(() => submitValidate('Submit'))}
                  />

                </BottomActionsContainer>
              </InputCont>
              <Confirm
                size='mini'
                open={showConfirm}
                onCancel={() => setShowConfirm(false)}
                onConfirm={() => submitAction()}
              />
            </DPContainer>
          </StdCard> : null
      }
      {
        valueForm.statusActivity === 'Procurement Review Interim' ?
          <StdCard title='Comment :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
            <DPContainer>
              <InputCont>
                <Field
                  name='comment'
                  label='Comment'
                  type={type.textArea}
                  containerStyle={{ marginRight: '0px' }}
                  component={FieldInput} />
                <Field name='DP02' label='Require Payment Certificate / Interim Payment / Acknowledged Doc. :' type={type.file} component={FieldInput} />

                <BottomActionsContainer>
                  <Button
                    type='submit'
                    content='Submit'
                    color='green'
                    onClick={handleSubmit(() => submitValidate('Submit'))}
                  />

                </BottomActionsContainer>
              </InputCont>
              <Confirm
                size='mini'
                open={showConfirm}
                onCancel={() => setShowConfirm(false)}
                onConfirm={() => submitAction()}
              />
            </DPContainer>
          </StdCard> : null
      }
      {valueForm.statusActivity === 'Account Approve' ?
        <StdCard title='Comment :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
          <DPContainer>
            <InputCont>
              {
                valueForm.statusActivity === 'Account Approve' ?
                  <Field
                    name='comment'
                    label='Comment'
                    type={type.textArea}
                    containerStyle={{ marginRight: '0px' }}
                    component={FieldInput} /> :
                  <Field name='DP02' label='Require Payment Certificate / Interim Payment / Acknowledged Doc. :' type={type.file} component={FieldInput} require />
              }
              <BottomActionsContainer>
                {
                  valueForm.statusActivity === 'Account Approve' ?
                    <Button
                      type='submit'
                      content='Accept'
                      color='green'
                      onClick={handleSubmit(() => submitValidate('Submit'))}
                    /> :
                    <Button
                      type='submit'
                      content='Submit'
                      color='green'
                      onClick={handleSubmit(() => submitValidate('send'))}
                    />
                }
                <Button
                  type='submit'
                  content='Revise To Purchase'
                  color='orange'
                  onClick={handleSubmit(() => submitValidate('Revise To Purchase'))}
                />
                {
                  dpDetail.isVendThai ?
                    <Button
                      type='submit'
                      content='Revise To Vendor'
                      color='orange'
                      onClick={handleSubmit(() => submitValidate('Revise To Vendor'))}
                    /> : null
                }
                {
                  valueForm.statusActivity === 'Procurement Check Document' ?
                    <Button
                      type='submit'
                      content='Cancel'
                      color='red'
                      onClick={handleSubmit(() => submitValidate('cancel'))}
                    /> : null
                }
              </BottomActionsContainer>
            </InputCont>
            <Confirm
              size='mini'
              open={showConfirm}
              onCancel={() => setShowConfirm(false)}
              onConfirm={() => submitAction()}
            />
          </DPContainer>
        </StdCard> : null
      }

      {valueForm.statusActivity === 'Account Approve DP' ?
        <StdCard title='Payment Type :' highlight style={{ marginTop: '1rem' }} enableCollapse={false} >
          <Field
            name="paymentType"
            label="PaymentType"
            type={type.radio}
            require
            options={
              dpDetail.isVendThai ? [
                { text: 'Cash', value: 'cash' },
                { text: 'Cheque', value: 'cheque' },
                { text: 'Transfer', value: 'transfer' }] :
                [{ text: 'Wire Tranfer', value: 'wireTranfer' }]
            }
            editable={dpDetail.isVendThai}
            component={FieldInput}
          />
          <Field
            name="dueDate"
            label="Due Date"
            className='halfRow'
            type={type.date}
            editable={false}
            component={FieldInput}
          />
          <br />
          {r.log({ valueForm })}
          <InputCont>
            <Field
              name='comment'
              label='Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
          </InputCont>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
          <BottomActionsContainer>
            <Button
              type='submit'
              content='Submit'
              color='green'
              onClick={handleSubmit(() => submitValidate('submit'))}
            />

            <Button
              type='submit'
              content='Revise To Purchase'
              color='orange'
              onClick={handleSubmit(() => submitValidate('Revise To Purchase'))}
            />
          </BottomActionsContainer>
        </StdCard>
        : null
      }
    </React.Fragment>
  )
}



export const validateField = (values, actionName) => {
  let errors = {}
  if (actionName === 'revise') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'send') {
    if (values.downPaymentProjectOwnerItems.length <= 0) {
      errors.downPaymentProjectOwnerItems = 'Required!'
    }
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
  }
  if (actionName === 'cancel') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'Revise To Purchase') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'Revise To Vendor') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'submit') {
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
    if (!values.paymentType) {
      errors.paymentType = 'Required!'
    }
    if (!values.invoiceNumber) {
      errors.invoiceNumber = 'Required!'
    }
    if (!values.invoiceDate) {
      errors.invoiceDate = 'Required!'
    }
    if (values.statusActivity === 'Procurement Upload Document') {
      if (!values.DP01 || !values.DP01.length) {
        errors.DP01 = 'Required!'
      }
    }
    if (values.statusActivity === 'Project Owner') {
      if (!values.DP02 || !values.DP02.length) {
        errors.DP02 = 'Required!'
      }
    }

  }
  return errors
}

const mapStateToProps = (state) => {
  return ({
    dpDetail: state.downPayment.downPaymentDetail.data,
    members: state.member.members,
    valueForm: getFormValues('formDP')(state),
  })
}

const mapDispatchToProps = {
  approverDownPaymentAction,
  setDownpaymentActionName,
  updateDownPayment,
  getHrmsMembers,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(Requestdocument)